import { getToken } from '../services/getToken'
import jwt from 'jsonwebtoken'

export const getTokenPayload = () => {
  const payload = jwt.decode(getToken())
  return payload
}